// Module
var code = " <div class=\"linechart\"> <canvas id=\"base\" class=\"chart chart-bar\" chart-data=\"hbar.chart.data\" chart-options=\"hbar.chart.options\" chart-labels=\"hbar.chart.labels\" chart-colors=\"hbar.chart.colours\" height=\"300\"> </canvas> </div>";
// Exports
module.exports = code;